import SJButton from '@/components/SJButton'
import { checkCanRegistration } from '@/services/accredit'
import { CheckReq, CheckRes } from '@/services/types/accredit'
import { useEffect, useState } from 'react'
import SJSite from '@/components/SJSite'
import images from '@/assets/images'
import { useNavigate, useSearchParams } from 'react-router-dom'
import user from '@/stores/user'
import SJAvatar from '@/components/SJAvatar'
import accredit from '@/stores/accredit'
import { observer } from 'mobx-react'
import './index.less'

const RegistrationGrade = () => {
  document.title = '评测等级'
  const navigate = useNavigate()
  const [searchParmas] = useSearchParams()
  const playerId = searchParmas.get('playerId') || ''
  accredit.applicant_id = playerId
  const [can, setCan] = useState(false)
  const [grade, setGrade] = useState(16)
  const [loading, setLoading] = useState(true)

  const handleCheck = async () => {
    const params: CheckReq = {
      // broker_id: String(user.userInfo.id),
      applicant_id: playerId,
      // applying_for_grade: 16,
    }
    try {
      const res = (await checkCanRegistration(params)) as unknown as CheckRes
      setGrade(res.grade)
      accredit.applicant_grade = Number(res.grade)
      setCan(res.result)
      setLoading(false)
    } catch (error: any) {
      setGrade(error.data.grade)
      accredit.applicant_grade = Number(error.data.grade)
      setCan(error.data.result)
      console.log('checkCanRegistration', error)
      setLoading(false)
    }
  }

  useEffect(() => {
    handleCheck()
  }, [])

  const goStart = () => {
    if (!can) return
    navigate('/registration/notice', { state: { grade } })
  }

  return (
    <div className="page registration-grade">
      {loading ? (
        <SJSite></SJSite>
      ) : (
        <>
          <SJAvatar
            className="page-avatar"
            src={user.curPlayer.avatarUrl}
            name={user.curPlayer.name}
          ></SJAvatar>
          <div className="main">
            <div className="card" style={{ backgroundImage: `url(${images.certification_bg})` }}>
              <div className="title">中国象棋协会</div>
              <div className="title2">#评测等级#</div>
              <div className="num">
                {grade}
                <span className="ji"> 级</span>
              </div>
            </div>
            <div className="tip">*只为设备上【已注册】的棋手提供评测服务</div>
          </div>
        </>
      )}
      <div className="btn-fixed">
        <SJButton type="primary" size="large" onClick={goStart} disabled={!can}>
          开始报名
        </SJButton>
      </div>
    </div>
  )
}
export default observer(RegistrationGrade)
